__turbopack_context__.v({
  "handle": "resizeHandle-module-scss-module__A-6lJq__handle",
});
